import axios from "axios";

const state = () => ({
    isBusy: false,
    game: null,
    question: null,
    player: null,
    financial: null
})

// mutations
const mutations = {
    setIsBusy(state, data) {
        state.isBusy = data;
    },
    setGame(state, data) {
        state.game = data;
    },
    setQuestion(state, data) {
        state.question = data;
    },
    setPlayer(state, data) {
        state.player = data;
    },
    setFinancial(state, data) {
        state.financial = data;
    }
}

// actions
const actions = {
    getGame({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/game?';
        url = date.ageRange ? `${url}&ageRange=${date.ageRange}` : url;
        url = date.country ? `${url}&country=${date.country}` : url;
        url = date.gender ? `${url}&gender=${date.gender}` : url;
        url = date.dateFrom ? `${url}&dateFrom=${date.dateFrom}` : url;
        url = date.dateTo ? `${url}&dateTo=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setGame', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getQuestion({commit}, locale) {
        commit('setIsBusy', true);

        let url = `/api/report/question?locale=${locale}`;

        axios.get(url)
            .then(function (response) {
                commit('setQuestion', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getPlayer({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/player?';

        url = date.ageRange ? `${url}&ageRange=${date.ageRange}` : url;
        url = date.country ? `${url}&country=${date.country}` : url;
        url = date.gender ? `${url}&gender=${date.gender}` : url;
        url = date.dateFrom ? `${url}&dateFrom=${date.dateFrom}` : url;
        url = date.dateTo ? `${url}&dateTo=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setPlayer', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getFinancial({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/financial?';

        url = date.ageRange ? `${url}&ageRange=${date.ageRange}` : url;
        url = date.country ? `${url}&country=${date.country}` : url;
        url = date.gender ? `${url}&gender=${date.gender}` : url;
        url = date.dateFrom ? `${url}&dateFrom=${date.dateFrom}` : url;
        url = date.dateTo ? `${url}&dateTo=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setFinancial', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
